export enum DashboardReportType {
    ACCOUNT_HEALTH = 'account-health',
    STRATEGIC_BUSINESS_REVIEW = 'strategic-business-review',
    ACCOUNT_OVERVIEW = 'account-overview'
}
